export const getPublicationDate = (publication_date: string) => {
  return publication_date.slice(0, -9);
};
